import React, { useEffect, useState, useRef } from 'react';
import BannerImg from '../../../assets/Illustration/line.jpg';

const BannerWithFadingGridBackground = () => {
  const gridItems = Array.from({ length: 60 });

  const [isTextVisible, setIsTextVisible] = useState(false);
  const [isImageVisible, setIsImageVisible] = useState(false);

  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const observerOptions = { threshold: 0.1 };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === textRef.current) {
          setIsTextVisible(entry.isIntersecting);
        }
        if (entry.target === imageRef.current) {
          setIsImageVisible(entry.isIntersecting);
        }
      });
    }, observerOptions);

    if (textRef.current) observer.observe(textRef.current);
    if (imageRef.current) observer.observe(imageRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className='relative min-h-screen flex flex-col justify-center px-8 py-4'>
      {/* Grid Background */}
      <div className='absolute inset-0'>
        <div
          className='grid grid-cols-8 grid-rows-8 w-full h-full opacity-10 dark:opacity-10'
          style={{
            maskImage: 'linear-gradient(to bottom, black 30%, transparent 70%)',
            WebkitMaskImage:
              'linear-gradient(to bottom, black 30%, transparent 70%)',
          }}
        >
          {gridItems.map((_, index) => (
            <div
              key={index}
              className='border border-black dark:border-gray-400'
            />
          ))}
        </div>
      </div>

      {/* Top Heading */}
      <div
        ref={textRef}
        className={`relative max-w-4xl mx-auto text-center transition-transform duration-1000 ease-in-out ${
          isTextVisible
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 -translate-y-10'
        }`}
      >
        <h1 className='text-4xl md:text-5xl font-bold text-gray-800 dark:text-gray-100 leading-tight'>
          Improve your shop-floor productivity through real-time CNC & Assembly
          Line Monitoring
        </h1>
      </div>

      {/* Bottom Content */}
      <div className='relative mt-24 max-w-7xl mx-auto w-full flex md:flex-row sm:flex-col xs:flex-col items-center justify-between gap-16'>
        {/* Left Image */}
        <div
          ref={imageRef}
          className={`w-full md:w-[55%] flex justify-start transition-transform duration-1000 ease-in-out ${
            isImageVisible
              ? 'opacity-100 translate-x-0'
              : 'opacity-0 -translate-x-20'
          }`}
        >
          <img
            src={BannerImg}
            alt='banner-img'
            className='w-full object-cover rounded-xl shadow-2xl'
          />
        </div>

        {/* Right Text */}
        <div className='w-full md:w-[45%]'>
          <p className='text-xl md:text-3xl text-gray-800 dark:text-white text-start'>
            Discover More About CNC & Assembly Line Monitoring
          </p>
        </div>
      </div>
    </div>
  );
};

export default BannerWithFadingGridBackground;
